import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { FILE_BASE_URL } from '../../Services/baseApiUrl';

function ViewVehicleDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const vehicleDetails = location.state?.vehicleDetails || {};
  const getImageSource = (file) => {
    return FILE_BASE_URL + file;
  };

  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className='row text-end'>
                <div className='col'>
                  <button type="button" class="btn btn-danger"
                    style={{
                      backgroundColor: "rgb(236, 17, 23)"
                    }}
                    onClick={() => navigate("/vehicle")}
                  >
                    Back
                  </button>
                </div>
              </div>
              <h4 style={{ display: "flex", marginBottom: "30px" }}>
                Vehicle Details of :  {vehicleDetails.vehicle_type_name}
              </h4>
              <div className="card">
                <div className="p-3">
                  <div className="text-start mb-3">
                    <div className="row"> 
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Collection Type Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="collection_type_name"
                            readOnly
                            value={vehicleDetails.collection_type_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">UID</label>
                          <input
                            type="text"
                            name="vehicle_uid"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.vehicle_uid}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Register text</label>
                          <input
                            type="text"
                            name="register_no"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.register_no}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Chassis text</label>
                          <input
                            type="text"
                            name="chassis_no"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.chassis_no}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Owner Type Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="owner_type_name"
                            readOnly
                            value={vehicleDetails.owner_type_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Zone</label>
                          <input
                            type="text"
                            name="zone_name"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.zone_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Circle</label>
                          <input
                            type="text"
                            name="circle_name"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.circle_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Ward</label>
                          <input
                            type="text"
                            name="ward_name"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.ward_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Driver Name</label>
                          <input
                            type="text"
                            name="driver_name"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.driver_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Incharge Name</label>
                          <input
                            type="text"
                            name="incharge_name"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.incharge_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Transfer Station Name</label>
                          <input
                            type="text"
                            name="transfer_station_name"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.transfer_station_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Deployment Location Name</label>
                          <input
                            type="text"
                            name="deployment_location_name"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.deployment_location_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">LandMark</label>
                          <input
                            type="text"
                            name="landmark"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.landmark}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Gross Weight</label>
                          <input
                            type="text"
                            name="gross_weight"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.gross_weight}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Tare Weight</label>
                          <input
                            type="text"
                            name="tare_weight"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.tare_weight}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Net Weight</label>
                          <input
                            type="text"
                            name="net_weight"
                            className="form-control"
                            readOnly
                            value={vehicleDetails.net_weight}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">File</label>
                          {vehicleDetails.file && (
                            <img
                              src={getImageSource(vehicleDetails.file)}
                              alt="TransferStation Image"
                              style={{ maxWidth: "100%", marginTop: "10px" }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Status</label>
                          <input
                            type="text"
                            className="form-control"
                            name="status"
                            readOnly
                            value={vehicleDetails.status === "1" ? "Active" : "Inactive"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewVehicleDetails
